module.exports = __webpack_public_path__ + "img/logo.bcb81162.png";